<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-row>
          <b-col md="2">
            <span class="tabtext">{{ current_seating.DateOfSeating }}</span>
          </b-col>
          <b-col md="1">
            <span class="tabtext">{{ RSVPs }}</span>
          </b-col>
          <b-col md="1">
            <span class="tabtext">{{ Waits }}</span>
          </b-col>
          <b-col md="1">
            <span class="tabtext">{{ Attendees }}</span>
          </b-col>
          <b-col md="2">
            <span class="tabtext">${{ Cost }}</span>
          </b-col>
          <b-col md="2" v-if="!current_seminar.IsSplit" class="ml-1">
            <span class="tabtext">{{ RSVPMod }}%</span>
          </b-col>
          <!-- <b-col md="2" v-if="!current_seminar.IsSplit" class="ml-1">
            <span class="tabtext">${{ RSVPCost }}</span>
          </b-col> -->
          <b-col md="2" v-if="current_seminar.IsSplit" class="ml-0">
            <span class="tabtext">{{ RSVP_A_Mod }}%</span>
          </b-col>
          <!-- <b-col md="1" v-if="current_seminar.IsSplit" class="ml-1">
            <span class="tabtext">${{RSVP_A_Cost}}</span>
          </b-col> -->
          <b-col md="2" v-if="current_seminar.IsSplit" class="ml-0">
            <span class="tabtext">{{ RSVP_B_Mod }}%</span>
          </b-col>
          <!-- <b-col md="1" v-if="current_seminar.IsSplit" class="ml-1">
            <span class="tabtext">${{RSVP_B_Cost}}</span>
          </b-col> -->
          <b-col md="1" v-if="current_seminar.IsSplit" class="ml-0">
            <span class="tabtext">{{ RSVPMod }}%</span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "StatisticsContainer",
  props: {
    seating_object: { type: Object },
    //aggregate_object: { type: Object },
    seminar_object: { type: Object },
  },
  data() {
    return {
      current_seating: this.seating_object,
      //current_aggregate: this.aggregate_object,
      current_seminar: this.seminar_object,
    };
  },
  computed: {
    RSVPs() {
      return (
        Number(this.seating_object.Attendee1Count) +
        Number(this.seating_object.Attendee2Count)
      );
    },
    Waits() {
      return (
        Number(this.seating_object.WaitList1Count) +
        Number(this.seating_object.WaitList2Count)
      );
    },
    Attendees() {
      return Number(this.RSVPs) + Number(this.Waits);
    },

    Quantity() {
      var _retObj = "N/A";
      if (this.current_seminar.Seatings.length > 0) {
        _retObj =
          (Number(this.seminar_object.Quantity1) +
            Number(this.seminar_object.Quantity2)) /
          this.current_seminar.Seatings.length;
      }
      return _retObj;
    },
    Cost() {
      var _retObj = 0;
      if (this.current_seminar.Seatings.length > 0) {
        _retObj =
          (Number(this.seminar_object.Cost1) +
            Number(this.seminar_object.Cost2)) /
          this.current_seminar.Seatings.length;
      }
      return _retObj.toFixed(2);
    },
    RSVPMod() {
      var _retObj = 0;
      if (this.Quantity > 0) {
        _retObj = (Number(this.RSVPs) + Number(this.Waits)) / this.Quantity;
        _retObj *= 100;
      }
      return _retObj.toFixed(2);
    },
    RSVPCost() {
      var _retObj = 0;

      if (this.Attendees > 0) {
        _retObj = this.Cost / this.Attendees;
      }
      return _retObj.toFixed(2);
    },
    RSVP_A_Mod() {
      var _retObj = 0;
      if (this.Quantity > 0) {
        _retObj =
          (Number(this.seating_object.Attendee1Count) +
            Number(this.seating_object.WaitList1Count)) /
          this.seminar_object.Quantity1;
        _retObj *= 100;
      }
      return _retObj.toFixed(2);
    },
    RSVP_A_Cost() {
      var _retObj = 0;
      var _attendees =
        Number(this.seating_object.Attendee1Count) +
        Number(this.seating_object.WaitList1Count);

      if (_attendees > 0) {
        _retObj =
          this.seminar_object.Cost1 /
          this.current_seminar.Seatings.length /
          _attendees;
      }
      return _retObj.toFixed(2);
    },
    RSVP_B_Mod() {
      var _retObj = 0;
      if (this.Quantity > 0) {
        _retObj =
          (Number(this.seating_object.Attendee2Count) +
            Number(this.seating_object.WaitList2Count)) /
          this.seminar_object.Quantity2;
        _retObj *= 100;
      }
      return _retObj.toFixed(2);
    },
    RSVP_B_Cost() {
      var _retObj = 0;
      var _attendees =
        Number(this.seating_object.Attendee2Count) +
        Number(this.seating_object.WaitList2Count);

      if (_attendees > 0) {
        _retObj =
          this.seminar_object.Cost2 /
          this.current_seminar.Seatings.length /
          _attendees;
      }
      return _retObj.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>